/**
 * Normalise a patient id for consistent comparisons/paths.
 *
 * @param {unknown} v
 * @returns {string} trimmed patient id or "" if empty/invalid
 */
export function normalizeId(v) {
  if (v === undefined || v === null) return "";
  const s = String(v).trim();
  return s.length ? s : "";
}

/**
 * Builds the Cloud Storage directory path for metadata for a given uid + patient context.
 *
 * Rules:
 * - No patient id => "user_metadata/{uid}"
 * - Patient id present => "user_metadata/{uid}/{id}"
 *
 * @param {string} uid
 * @param {string|undefined|null} id
 * @returns {string}
 */
export function metadataDirPath(uid, id) {
  const pid = normalizeId(id);
  return pid ? `user_metadata/${uid}/${pid}` : `user_metadata/${uid}`;
}

/**
 * Builds the Cloud Storage object path for a metadata JSON file.
 *
 * @param {string} uid
 * @param {string|undefined|null} id
 * @param {string} fileName
 * @returns {string}
 */
export function metadataFilePath(uid, id, fileName) {
  return `${metadataDirPath(uid, id)}/${fileName}`;
}

/**
 * A stable cache key for uid + patient context.
 *
 * @param {string} uid
 * @param {string|undefined|null} id
 * @returns {string}
 */
export function patientCacheKey(uid, id) {
  const pid = normalizeId(id);
  return `${uid}::${pid || "__self__"}`;
}
